/* ═══════════════════════════════════════════════════════════════════════════════════════════════════════════
   A SET: A SHORT LIST OF CARDS, AND A VISIT THAT STAYS INSIDE IT (Daniel, 18 Oct, for reviewers.com).

   Reviewers.com's creators land on one product page, never a catalogue (Lilach, 18 Oct: "they always land on a
   product page ... not on the home page with so many potential designs"), and their free code covers one card,
   quantity 1, so a card going abroad (a postage line) or a second card breaks it. A set is the answer, as one list:

     /products/picturepop?view=reviewers   the set's page (templates/product.reviewers.liquid, sections/pp-set.liquid)
     ?set=reviewers                        on every link out of it: the builder and the cart keep to the set

   While a set is on, in this tab:
     · the builder opens only the set's designs, and Change design goes back to the set's page (configurator.js);
     · Send has To me only: one card, to the person making it (builder-b.js ppbSendOpts, recipMax);
     · the address is US only, the same rule a US-only design already has (designShipsTo, cart-recipients.js);
     · the cart offers no second person and no second card, and links back to the set (cart-b.js).

   Remembered in sessionStorage, as the free-card claim is, so the trip from the page to the builder, the cart and
   Edit card keeps it; ?set=0 turns it off. A new tab is a normal visit. The set is display and guidance: it changes
   no order property (the order is the same Picturepop card, docs/2026-09-08-order-property-contract.md), and print
   never sees it.

   ⚠️ THE CHECKOUT IS NOT LOCKED BY THIS. Shopify's checkout still takes any country the International market ships
   to; the card itself carries its US address (`Delivery To`, `_Country`), which is what print posts to.
   ═══════════════════════════════════════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var KEY = 'pp_set_v1';

  var SETS = {
    reviewers: {
      home: '/products/picturepop-reviewers',
      /* The hidden product reviewers.com's campaign selects (Daniel, 19 Oct: orders must count for them). Its page is
         this set (template product.reviewers); every card added in the set goes in the cart as ITS variant, so the
         order line is that product. Same price as picturepop. Print reads properties, not the product. */
      variant: 63227175633036,
      sendTo: 'me',
      countries: ['US'],
      oneCard: true,
      // In this order on the page (Daniel's list, 18 Oct). Catalogue ids; grumpy-birthday is the theme's own
      // (assets/designs.json), every other one is the artists catalogue's.
      designs: [
        'artist-324bbbabfc3f4c00',   // The Moon's Voyage (Hokusai & Hiroshige)
        'artist-300fd42f52b649cb',   // The Waterfall's Voice (Hokusai & Hiroshige)
        'artist-7b510503bc9a4d9d',   // Poppies (Anne Pratt)
        'artist-eae909ca73c64856',   // Royal French Rose (Redouté)
        'artist-6f68f71d5fda44b0',   // Peach, 'Shipper' (Daniel, 19 Oct: Kuhl's Lorikeet was deleted with Yonatan's hold list)
        'grumpy-birthday',           // Grumpy Birthday (Picturepops)
        'artist-023147e525644ede',   // The Apple Rose (Redouté)
        'artist-334b596bd7624a84',   // Thank you berry much
        'artist-aedc1f73546a4e85',   // The Empress Josephine Rose (Redouté)
        'artist-f637fcc9144848f4'    // Squares from Euclid (Byrne)
      ]
    }
  };

  function fromUrl() {
    try {
      var v = new URLSearchParams(location.search).get('set');
      if (v === null) return undefined;
      return v;
    } catch (e) { return undefined; }
  }

  var name = null;
  var asked = fromUrl();
  if (asked === '0' || asked === '') {
    try { sessionStorage.removeItem(KEY); } catch (e) { /* nothing kept */ }
  } else if (asked && SETS[asked]) {
    name = asked;
    try { sessionStorage.setItem(KEY, asked); } catch (e) { /* the address carries it on this page */ }
  }
  if (!name) {
    try { var kept = sessionStorage.getItem(KEY); if (kept && SETS[kept]) name = kept; } catch (e) { /* none */ }
  }

  var set = name ? SETS[name] : null;

  window.PPSet = {
    name: name,
    active: function () { return set; },
    get: function (n) { return SETS[n] || null; },
    has: function (designId) { return !!set && set.designs.indexOf(designId) !== -1; },
    // A builder address for one of the set's designs, carrying the set.
    builderUrl: function (designId, n) {
      return '/products/picturepop?design=' + encodeURIComponent(designId) + '&set=' + encodeURIComponent(n || name);
    }
  };
})();
